
export function getGraphQLEndpoint() {
  return process.env.REACT_APP_API_URL;
}

export function getSupportEmail() {
  return "lenard.jablonski@campoint.net";
}